import script from "./MyInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./MyInfo.vue?vue&type=script&setup=true&lang=js"

import "./MyInfo.vue?vue&type=style&index=0&id=51cbad29&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51cbad29"]])

export default __exports__